<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-row :gutter="15">
        <!-- 部门列表 -->
        <el-col :md="5" style="margin-bottom: 15px">
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="departData"
              :props="{ label: 'departmentName' }"
              :expand-on-click-node="false"
              :default-expanded-keys="dataIdArr"
              node-key="id"
              @node-click="chooseDepart"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="19" style="margin-bottom: 15px">
          <!-- 搜索表单 -->
          <el-form label-width="77px" class="ele-form-search">
            <el-row :gutter="15">
              <el-col :md="6" :sm="12">
                <el-form-item label="日期:">
                  <el-date-picker v-model="date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
                </el-form-item>
              </el-col>
              <el-col :md="6" :sm="12">
                <div class="ele-form-actions">
                  <el-button type="primary" @click="queryTeacherAttendance(departmentId, date)" icon="el-icon-search" class="ele-btn-icon"
                    >查询
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="showAttendanceList" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">设置考勤时间</el-button>
            <el-button @click="showExport = true" type="primary" icon="el-icon-download" class="ele-btn-icon" size="small">导出 </el-button>
          </div>
          <!-- 数据表格 -->
          <ele-data-table ref="table" :config="table" :data="attendanceData" :choose.sync="choose" highlight-current-row>
            <template #default="{ index }">
              <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
              <el-table-column v-for="(item, index) in teacherAttendanceNameList" :key="index" :label="item">
                <template #default="{ row }">
                  <span v-if="item == '姓名' || item == '手机号'">{{ row[item] }}</span>
                  <el-tag v-else effect="dark" :type="row[item] === null ? 'danger' : 'success'">{{
                    row[item] === null ? '未打卡' : row[item]
                  }}</el-tag>
                </template>
              </el-table-column>
            </template>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
    <!--设置考勤时间弹窗-->
    <el-dialog
      title="考勤时间设置"
      :visible.sync="showSetTeacherAttendance"
      width="800px"
      @closed="attendanceListForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <ele-data-table ref="attendanceListTable" :data="attendanceListData" border :config="attendanceListTable" highlight-current-row>
        <el-table-column type="index" width="45" align="center" />
        <el-table-column label="名称" prop="attendanceName" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-input v-if="$index === editIndex" v-model="attendanceListForm.attendanceName" placeholder="请输入名称" />
            <span v-else>{{ row.attendanceName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" prop="beginTime" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-time-picker
              v-if="$index === editIndex"
              v-model="attendanceListForm.beginTime"
              placeholder="选择开始时间"
              value-format="HH:mm"
              format="HH:mm"
            />
            <span v-else>{{ row.beginTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间" prop="endTime" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-time-picker
              v-if="$index === editIndex"
              v-model="attendanceListForm.endTime"
              placeholder="选择结束时间"
              value-format="HH:mm"
              format="HH:mm"
            />
            <span v-else>{{ row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px" align="center" :resizable="false">
          <template #default="{ row, $index }">
            <div v-if="$index === editIndex">
              <el-link @click="onSaveattendance(row, $index)" icon="el-icon-check" type="success" :underline="false">保存 </el-link>
              <el-link @click="onCancelattendance(row, $index)" icon="el-icon-close" type="warning" :underline="false">取消 </el-link>
            </div>
            <div v-else>
              <el-link @click="onEditattendance(row, $index)" icon="el-icon-edit" type="primary" :underline="false">修改 </el-link>
              <span class="ele-action">
                <el-popconfirm title="确定要删除此考勤时间吗？" @onConfirm="onRemoveattendance(row, $index)">
                  <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                </el-popconfirm>
              </span>
            </div>
          </template>
        </el-table-column>
      </ele-data-table>
      <el-button @click="addAttendance" icon="el-icon-plus" style="width: 100%; margin-top: 15px">新增考勤时间</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeClose">取 消</el-button>
        <el-button type="primary" @click="beforeClose">确 定</el-button>
      </span>
    </el-dialog>
    <!--导出弹窗设置时间-->
    <el-dialog
      title="导出"
      :visible.sync="showExport"
      width="400px"
      @closed="exportForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form ref="exportForm" :model="exportForm" label-width="80px" :rules="exportRules">
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker v-model="exportForm.startTime" type="date" placeholder="选择开始日期" style="width: 80%" />
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="exportForm.endTime" type="date" placeholder="选择结束日期" style="width: 80%" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showExport = false">取 消</el-button>
        <el-button type="primary" @click="exportData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getTeacherAttendanceList,
    getTeacherAttendanceRecordBySchool,
    setTeacherAttendance,
    updateTeacherAttendance,
    deleteTeacherAttendance,
    exportTeacherAttendanceRecordBySchool,
    getAllDepartList,
  } from '@/config/api';

  export default {
    name: 'StudentRecord',
    data() {
      return {
        date: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
        table: {
          page: {
            page: 1,
            limit: 10,
          },
        },
        choose: [], // 表格选中数据
        attendanceData: [], //统计数据
        teacherAttendanceNameList: [], //表头数据
        showSetTeacherAttendance: false, //设置考勤时间弹窗
        attendanceListTable: {
          page: false,
        },
        attendanceListData: [],
        attendanceListForm: {
          attendanceName: '',
          beginTime: null,
          endTime: null,
        },
        editIndex: null,
        editType: 1,
        departData: [],
        dataIdArr: [],
        current: null, // 部门选中数据
        showExport: false,
        exportForm: {
          startTime: null,
          endTime: null,
        },
        exportRules: {
          startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        },
        departmentId: null,
      };
    },
    mounted() {
      this.queryDepart();
    },
    methods: {
      /* 查询 */
      queryDepart() {
        this.loading = true;
        getAllDepartList(this.where).then((res) => {
          this.loading = false;
          if (res.data.resCode == 200) {
            this.departData = this.$util.toTreeData(res.data.data, 'id', 'parentId');
            this.dataIdArr = this.$util.getTreeFloor(this.departData, 1, this.dataIdArr, 'id');
            setTimeout(() => {
              this.chooseDepart(this.departData[0]); //默认首先选择学校
            }, 100);
          } else {
            this.$message.error(res.data.resMsg || '获取数据失败');
          }
        });
      },
      chooseDepart(row) {
        if (row != null) {
          this.current = row;
          this.$refs.orgTree.setCurrentKey(row.id);
          this.departmentId = row.id;
          this.queryTeacherAttendance(row.id, this.date);
        } else {
          this.current = null;
        }
      },
      // 查询考勤统计
      queryTeacherAttendance(departmentId, date) {
        let data = {
          date: date,
          departmentId: departmentId,
        };
        getTeacherAttendanceRecordBySchool(data).then((res) => {
          if (res.data.resCode == 200) {
            this.attendanceData = res.data.data.records;
            this.teacherAttendanceNameList = res.data.data.teacherAttendanceNameList;
          }
        });
      },
      // 打开弹窗并且获取考勤内容数据
      showAttendanceList() {
        this.showSetTeacherAttendance = true;
        getTeacherAttendanceList().then((res) => {
          if (res.data.resCode == 200) {
            this.attendanceListData = res.data.data;
          }
        });
      },
      // 新增考勤时间
      addAttendance() {
        this.editType = 1;
        if (this.attendanceListData.length == 0) {
          this.attendanceListData.push({ __is_add: true });
          this.attendanceListForm = {
            attendanceName: '',
            beginTime: null,
            endTime: null,
          };
          this.editIndex = 0;
        }
        if (this.attendanceListData[this.attendanceListData.length - 1].__is_add) return;
        this.attendanceListData.push({ __is_add: true });
        this.attendanceListForm = {
          attendanceName: '',
          beginTime: null,
          endTime: null,
        };
        this.editIndex = this.attendanceListData.length - 1;
      },
      // 取消编辑
      onCancelattendance(row, index) {
        if (row.__is_add) this.attendanceListData.splice(index, 1);
        this.editIndex = null;
        this.attendanceListForm = {};
      },
      // 保存编辑
      onSaveattendance(row, index) {
        if (!this.attendanceListForm.attendanceName) return this.$message.error('请输入名称');
        if (!this.attendanceListForm.beginTime) return this.$message.error('请选择开始时间');
        if (!this.attendanceListForm.endTime) return this.$message.error('请选择结束时间');
        let data = new FormData();
        for (let key in this.attendanceListForm) {
          if (this.attendanceListForm[key] !== null && this.attendanceListForm[key] !== undefined) {
            data.append(key, this.attendanceListForm[key]);
          }
        }
        if (this.editType == 1) {
          //添加
          setTeacherAttendance(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.showAttendanceList();
              this.attendanceListData[index] = Object.assign({}, this.attendanceListForm, { __is_add: false });
              this.editIndex = null;
              this.attendanceListForm = {};
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        } else {
          //修改
          updateTeacherAttendance(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.attendanceListData[index] = Object.assign({}, this.attendanceListForm, { __is_add: false });
              this.showAttendanceList();
              this.editIndex = null;
              this.attendanceListForm = {};
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      // 修改行
      onEditattendance(row, index) {
        this.editType = 2;
        this.editIndex = index;
        this.attendanceListForm = Object.assign({}, row);
      },
      /* 删除行 */
      onRemoveattendance(row, index) {
        this.attendanceListData.splice(index, 1);
        let data = new FormData();
        data.append('id', row.id);
        deleteTeacherAttendance(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 考勤内容设置弹窗 关闭前
      beforeClose() {
        if (this.editIndex != null) {
          this.$message.error('请先保存数据！');
        } else {
          this.showSetTeacherAttendance = false;
          this.queryTeacherAttendance(this.date);
        }
      },
      // 导出数据
      exportData() {
        this.$refs['exportForm'].validate((valid) => {
          if (valid) {
            let data = {
              departmentId: this.departmentId,
              startTime: this.$util.toDateString(this.exportForm.startTime, 'yyyy-MM-dd'),
              endTime: this.$util.toDateString(this.exportForm.endTime, 'yyyy-MM-dd'),
            };
            exportTeacherAttendanceRecordBySchool(data).then((res) => {
              let blob = new Blob([res.data], {
                type: 'application/octet-stream',
              });
              let objectUrl = URL.createObjectURL(blob);
              let link = document.createElement('a');
              link.style.display = 'none';
              link.href = objectUrl;
              let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link); // 下载完成移除元素
              window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
            });
            this.showExport = false;
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped>
  /deep/ .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 150px;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(115vh - 262px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
